import { useAuthStore } from '@/stores/auth-store';
import { getCurrentEnvironment } from '@/utils/environment.utils';
import { clearUserContext, setStaticContext, setUserContext } from './middleware/context-enricher';

export function initLoggerContext(): void {
  setStaticContext({
    'deployment.environment': getCurrentEnvironment(),
  });

  const initialUser = useAuthStore.getState().user;
  if (initialUser) {
    setUserContext(initialUser.id);
  }

  useAuthStore.subscribe(
    (state) => state.user,
    (user) => {
      if (user) {
        setUserContext(user.id);
      } else {
        clearUserContext();
      }
    }
  );
}
